import { api } from '@/api';
import { GuardOwnerType } from '@/enums/guard';

const BindingApiByOwnerType = {
  [GuardOwnerType.Customer]: api.syncCustomerPlanGuards,
  [GuardOwnerType.CrmApartment]: api.syncCrmApartmentPlanGuards,
  [GuardOwnerType.CrmPlan]: api.syncCrmPlanPlanGuards,
};

export default {
  namespaced: true,
  state: {
    items: [],
    isLoading: false,
    current: {
      isLoading: false,
    },
  },
  mutations: {
    setGuards(state, items) {
      state.items = items;
    },
    setLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    setCurrentGuard(state, data) {
      state.current = {
        ...state.current,
        ...data,
      };
    },
    resetCurrentGuard(state) {
      state.current = { isLoading: false };
    },
  },
  actions: {
    getList(store, params = {}) {
      store.commit('setLoading', true);

      return api.getPlanGuards(params)
        .then(({ data }) => store.commit('setGuards', data.data ?? data))
        .finally(() => store.commit('setLoading', false));
    },

    async getGuard({ commit }, id) {
      commit('setCurrentGuard', { isLoading: true });
      try {
        const { data } = await api.getPlanGuardById(id);
        const guard = data.data ?? data;
        commit('setCurrentGuard', { ...guard, isLoading: false });
        return guard;
      } catch (error) {
        commit('setCurrentGuard', { isLoading: false });
        throw error;
      }
    },

    async createGuard({ dispatch }, request) {
      const { data } = await api.createPlanGuard(request);
      await dispatch('getList');
      return data.data ?? data;
    },

    async updateGuard({ commit }, { id, request }) {
      const { data } = await api.editPlanGuard(id, request);
      const guard = data.data ?? data;
      commit('setCurrentGuard', { ...guard, isLoading: false });
      return guard;
    },

    async syncBindings({ dispatch }, { ownerType, ownerId, guardIds }) {
      const request = BindingApiByOwnerType[ownerType];
      if (!request) throw new Error(`Unknown guard owner type: ${ownerType}`);

      await request(ownerId, { plan_guard_ids: guardIds });
      await dispatch('getList');
    },

    async deleteGuard({ state, commit }, id) {
      await api.deletePlanGuard(id);
      commit('setGuards', state.items.filter((item) => item.id !== id));
    },
  },
};
